import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fe3985a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid shadow-sm py-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Personal Details", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "p-float-label prime_input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, [
  /*#__PURE__*/_createTextVNode("First Name "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_7 = { class: "errorMsg" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "p-float-label prime_input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, "Middle Name", -1))
const _hoisted_11 = { class: "errorMsg" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "p-float-label prime_input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastname" }, [
  /*#__PURE__*/_createTextVNode("Last Name "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_15 = { class: "errorMsg" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "p-float-label prime_input" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "employeeNumber" }, [
  /*#__PURE__*/_createTextVNode("Employee Number (Ministry of Health) "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_19 = { class: "errorMsg" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "p-float-label prime_input" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_23 = { class: "errorMsg" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "reason" }, [
  /*#__PURE__*/_createTextVNode("Comment"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-2" }, "*")
], -1))
const _hoisted_26 = { class: "w-100 text-muted d-flex justify-content-end mr-3" }
const _hoisted_27 = { class: "errorMsg" }
const _hoisted_28 = { class: "d-flex justify-content-lg-end flex-md-wrap my-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ApprovalDetails = _resolveComponent("ApprovalDetails")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      action: "",
      onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "firstname",
              name: "firstname",
              modelValue: _ctx.firstname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event)),
              autocomplete: "firstname"
            }, null, 8, ["modelValue"]),
            _hoisted_6
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.firstnameError), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "middlename",
              name: "middlename",
              modelValue: _ctx.middlename,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.middlename) = $event)),
              autocomplete: "other-name"
            }, null, 8, ["modelValue"]),
            _hoisted_10
          ]),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.middlenameError), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "lastname",
              name: "lastname",
              modelValue: _ctx.lastname,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lastname) = $event)),
              autocomplete: "lastname"
            }, null, 8, ["modelValue"]),
            _hoisted_14
          ]),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.lastnameError), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "employeeNumber",
              name: "employeeNumber",
              modelValue: _ctx.employeeNumber,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.employeeNumber) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_18
          ]),
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.employeeNumberError), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, [
            _createVNode(_component_InputText, {
              type: "email",
              id: "email",
              name: "email",
              modelValue: _ctx.email,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_22
          ]),
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.emailError), 1)
        ])
      ]),
      _createVNode(_component_ApprovalDetails),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.reason,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reason) = $event)),
          id: "reason",
          name: "reason",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100",
          maxlength: "200"
        }, null, 8, ["modelValue"]),
        _createElementVNode("small", _hoisted_26, _toDisplayString(_ctx.reason?.length || 0) + "/200", 1),
        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.reasonError), 1)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_BaseButton, {
          type: "button",
          customStyle: _ctx.buttonStyleEdit,
          onClick: _ctx.onEdit
        }, {
          default: _withCtx(() => [
            _createTextVNode("Edit Health Needs")
          ]),
          _: 1
        }, 8, ["customStyle", "onClick"]),
        _createVNode(_component_BaseButton, {
          type: "button",
          onClick: _ctx.onReject,
          disabled: _ctx.loadingReject,
          class: _normalizeClass({ submitting: _ctx.loadingReject }),
          customStyle: _ctx.buttonStyleReject
        }, {
          default: _withCtx(() => [
            _createTextVNode("Reject")
          ]),
          _: 1
        }, 8, ["onClick", "disabled", "class", "customStyle"]),
        _createVNode(_component_BaseButton, {
          type: "submit",
          disabled: _ctx.loading,
          class: _normalizeClass({ submitting: _ctx.loading }),
          customStyle: _ctx.buttonStyle
        }, {
          default: _withCtx(() => [
            _createTextVNode("Approve")
          ]),
          _: 1
        }, 8, ["disabled", "class", "customStyle"])
      ])
    ], 32)
  ]))
}